import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CapturumBuilderDateInputComponent } from '@capturum/builders/form-renderer';
import { FormStateService } from '@core/services/form-state.service';
import { FormType } from '@core/enums/form-type.enum';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
      .disabled {
        height: 38px;
        border: 1px solid #ddd;
        border-radius: 3px;
        background-color: #f9f9f9;
        padding-left: 11px;
        font-size: 14px;
      }
    `,
    ],
    standalone: false
})
export class DatepickerComponent extends CapturumBuilderDateInputComponent {
  protected readonly FormControl = FormControl;
  public readonly today = new Date();
  public readonly type = FormType;
  public readonly isFormDisabled = toSignal(this.formStateService.onFormTypeChange, { initialValue: FormType.EDIT });

  constructor(private readonly formStateService: FormStateService) {
    super();
  }
}
